import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromPrediction from '../reducers/prediction.reducer';
export const selectPredictionState = createFeatureSelector<fromPrediction.State>('prediction');
export const selectPredictions = createSelector(
  selectPredictionState,
  (state: fromPrediction.State) => state.predictions
);
export const selectPredictionErrorMessage = createSelector(
  selectPredictionState,
  (state: fromPrediction.State) => state.errorMessage
);
export const selectIsLoading = createSelector(
  selectPredictionState,
  (state: fromPrediction.State) => state.isLaoding
);
export const selectUserHistoryPredictions = createSelector(
  selectPredictionState,
  (state: fromPrediction.State) => state.userHistoryPredictions
);

export const selectSelectedPrediction = createSelector(
  selectPredictionState,
  (state: fromPrediction.State) => state.selectedPrediction[0]
);

export const selectCreateSuccess = createSelector(
  selectPredictionState,
  (state: fromPrediction.State) => state.createSuccess
);

